/* Gallery lightbox — click-to-zoom, keyboard nav, swipe, image counter. */
(function () {
  if (!document.querySelector('.gallery-container')) return;

  const images = [...document.querySelectorAll('.gallery-container img')];
  if (!images.length) return;

  // Build lightbox DOM safely (no innerHTML)
  const overlay = document.createElement('div');
  overlay.className = 'gallery-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Image lightbox');

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'gallery-lightbox__close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '×';

  const prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'gallery-lightbox__nav gallery-lightbox__nav--prev';
  prevBtn.setAttribute('aria-label', 'Previous');
  prevBtn.textContent = '‹';

  const stage = document.createElement('div');
  stage.className = 'gallery-lightbox__stage';

  const lbImg = document.createElement('img');
  lbImg.alt = '';

  const nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'gallery-lightbox__nav gallery-lightbox__nav--next';
  nextBtn.setAttribute('aria-label', 'Next');
  nextBtn.textContent = '›';

  const counter = document.createElement('div');
  counter.className = 'gallery-lightbox__counter';
  counter.setAttribute('aria-live', 'polite');

  stage.append(lbImg);
  overlay.append(closeBtn, prevBtn, stage, nextBtn, counter);
  document.body.appendChild(overlay);

  let currentIndex = 0;
  let isAnimating = false;

  const updateCounter = () => {
    counter.textContent = `${currentIndex + 1} / ${images.length}`;
  };

  const open = (i, direction = 0) => {
    currentIndex = i;
    const img = images[i];
    if (direction !== 0 && lbImg.src) {
      // Animate transition
      isAnimating = true;
      lbImg.style.opacity = '0';
      lbImg.style.transform = `translateX(${direction * -20}px)`;
      setTimeout(() => {
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.alt || '';
        lbImg.style.transform = `translateX(${direction * 20}px)`;
        requestAnimationFrame(() => {
          lbImg.style.transition = 'opacity 0.35s ease, transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)';
          lbImg.style.opacity = '1';
          lbImg.style.transform = 'translateX(0)';
          setTimeout(() => { isAnimating = false; }, 350);
        });
      }, 180);
    } else {
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      lbImg.style.transition = 'none';
      lbImg.style.opacity = '1';
      lbImg.style.transform = 'translateX(0)';
    }
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    updateCounter();
  };

  const close = () => {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { lbImg.src = ''; lbImg.style.transform = ''; }, 350);
  };

  const next = () => { if (!isAnimating) open((currentIndex + 1) % images.length, 1); };
  const prev = () => { if (!isAnimating) open((currentIndex - 1 + images.length) % images.length, -1); };

  // Preload neighbors for smoother nav
  const preloadNeighbors = () => {
    [(currentIndex + 1) % images.length, (currentIndex - 1 + images.length) % images.length].forEach(i => {
      const pre = new Image();
      pre.src = images[i].currentSrc || images[i].src;
    });
  };

  // Bind clicks on every image
  images.forEach((img, i) => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      open(i);
      preloadNeighbors();
    });
    const wrap = img.closest('a, figure, div');
    if (wrap && wrap !== img) {
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('a[href]') && e.target.closest('a[href]') !== wrap) return;
        e.preventDefault();
        e.stopPropagation();
        open(i);
        preloadNeighbors();
      });
    }
  });

  closeBtn.addEventListener('click', close);
  nextBtn.addEventListener('click', (e) => { e.stopPropagation(); next(); preloadNeighbors(); });
  prevBtn.addEventListener('click', (e) => { e.stopPropagation(); prev(); preloadNeighbors(); });
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay || e.target === stage) close();
  });

  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') { next(); preloadNeighbors(); }
    if (e.key === 'ArrowLeft') { prev(); preloadNeighbors(); }
  });

  // Touch swipe — left/right to navigate, down to close
  let touchStartX = 0;
  let touchStartY = 0;
  overlay.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  overlay.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    const absX = Math.abs(dx);
    const absY = Math.abs(dy);
    if (absX > 50 && absX > absY) {
      if (dx < 0) next(); else prev();
      preloadNeighbors();
    } else if (dy > 80 && absY > absX) {
      close();
    }
  }, { passive: true });
})();
